module.exports = __webpack_public_path__ + "img/IndividualReports.74dc954d.svg";